<template>
  <div class="main-con" :style="{ height:'60vh' }">
    <el-row :gutter="30">
      <el-col :span="8">
        <el-card shadow="hover" v-loading="loading" style="{max-height:500px,overflow-y: scroll;}">
          <div slot="header" class="flex_between_center">
            <span>页面角色</span>
          </div>
          <div v-for="item in roleList" :key="item.role.role_code" :class="{'role':true ,'current-role':currentRole===item,'has-role':item.isWithPermission}" @click="handleDetail(item)">
            <div class="name">{{item.role.role_name}}</div>
            <div class="permission-list"><span class="title
            ">拥有权限: </span><span v-for="(rolePermission,index)  in  item.function_list" :key="index" class="single-permission">{{rolePermission.function_name}}</span>

            </div>
          </div>

        </el-card>

      </el-col>
      <el-col :span="14">
        <el-card shadow="hover" v-loading="listLoading">
          <div slot="header" class="flex_between_center">
            <span>角色权限</span>
          </div>
          <el-col :span="24">

            <div v-if="currentRole.hasOwnProperty('isWithPermission')&&!currentRole.isWithPermission"> 你没有该角色权限，无法查看</div>
            <el-tree v-if="functionList.length>0&&currentRole.isWithPermission" :data="functionList" node-key="id" :highlight-current="true" name="公司架构" :default-expand-all="false" :expand-on-click-node="true" :props="defaultProps" ref="tree">
              <span class="custom-tree-node" slot-scope="{ node, data }">
                <span class="fz-s">{{ node.label }}</span>
                <!-- 针对页面控件显示不可见，只读，无限制 -->
                <span class="fz-s" v-if="data.use_limit_flag=='-1'&&data.levle==2">(不可见)</span>
                <span class="fz-s" v-if="data.use_limit_flag=='0'&&data.levle==2">(只读)</span>
                <span class="fz-s" v-if="data.use_limit_flag=='9'&&data.levle==2">(无限制)</span>
              </span>
            </el-tree>
          </el-col>
        </el-card>
      </el-col>
    </el-row>
  </div>
</template>
<script>
import {
  GetAllFunctions,
  GetRoleInfoByCode,
  GetRoleList,
  GetRoleListByFunctionId,
  GetExportTaskList
} from '@/api/system'
export default {
  name: 'OakPagePermission',
  data() {
    return {
      loading: false,
      listLoading: false,
      currentRole: {},
      functionList: [],
      roleList: [],
      userRole: [],
      //搜索条件
      listQuery: {
        supplier_flag: '',
        role_code: ''
      },
      defaultProps: {
        children: 'children',
        label: 'function_name'
      },
      limitFunctionList: []
    }
  },
  methods: {
    initInfo() {
      this.getRoleList()
    },
    resetInfo() {
      this.currentRole = {}
    },
    //用户对应角色
    getRoleList() {
      this.loading = true
      GetRoleListByFunctionId({ path: this.$route.path }).then((response) => {
        this.loading = false
        if (response.data.res_status_code == 0) {
          this.roleList = response.data.res_content.result
          // this.userRole = this.roleList.map((item) => item.role_code)
        } else {
          this.$message({
            type: 'error',
            message: response.data.res_message
          })
        }
      })
    },
    //用户页面权限
    getInfo() {
      this.listLoading = true
      GetAllFunctions(this.listQuery).then((response) => {
        this.listLoading = false
        if (response.data.res_status_code == 0) {
          this.functionList = response.data.res_content
          //获取角色
          this.handleGetDetail()
        } else {
          this.$message({
            type: 'error',
            message: response.data.res_message
          })
        }
      })
    },

    handleDetail(item) {
      this.currentRole = item
      this.listQuery.role_code = item.role.role_code
      this.getInfo()
    },
    //给每个页面赋值use_limit_flag，通过use_limit_flag分辨只读，无限制，不可见
    updateFunctionList(tree, limitFunctionList) {
      function deepSearch(tree) {
        for (var i = 0; i < tree.length; i++) {
          if (tree[i].children && tree[i].children.length > 0) {
            deepSearch(tree[i].children)
          }
          var page = limitFunctionList.find(
            (item) => item.function_id === tree[i].id
          )
          if (page) {
            tree[i].use_limit_flag = page.use_limit_flag
          }
        }
      }
      deepSearch(tree)
    },
    //获取角色对应权限
    handleGetDetail() {
      GetRoleInfoByCode({ role_code: this.listQuery.role_code }).then(
        (response) => {
          this.listLoading = false
          if (response.data.res_status_code == 0) {
            this.limitFunctionList =
              response.data.res_content.available_function_list
            this.updateFunctionList(this.functionList, this.limitFunctionList)
          } else {
            this.$message({
              type: 'error',
              message: response.data.res_message
            })
          }
        }
      )
    }
  }
}
</script>
<style lang="scss" scoped>
.main-con {
  overflow-x: hidden;
  overflow-y: auto;
  .role-card {
    max-height: 500px;
    overflow-y: scroll;
  }

  .permission-list {
    .title {
      padding-right: 10px;
    }
    .single-permission {
      margin-right: 20px;
    }
  }
  .role {
    padding: 10px;
    margin-bottom: 10px;
    border: 1px solid #cccc;
    .name {
      margin-bottom: 5px;
    }
  }
  .current-role {
    border: 1px solid #4d939f;
  }
  .has-role {
    background-color: #acd0ce;
  }
}
</style>
